import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import toast from "react-hot-toast";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { TOAST_DURATION, TOAST_ERROR_COLOR, TOAST_POSITION } from "../../../../common/app_constant";
import { SUB_DIRECTORY } from "../../../../common/constant";
import ErrorLabel from '../../../../component/error_label';
import { actionLogin, resetLoginResponse } from "../store";


const Login = () => {

    let navigate = useNavigate()
    const dispatch = useDispatch()


    const { login } = useSelector((state) => ({
        ...state.publicStore
    }))

    const [passwordShown, setPasswordShown] = useState(false);

    const togglePasswordVisiblity = () => {
        setPasswordShown(passwordShown ? false : true);
    };

    const {
        register,
        formState: { errors },
        handleSubmit,
    } = useForm({
        defaultValues: {
            email: "",
            password: "",
        },
    });

    useDispatch(() => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        })
    }, [])

    useEffect(() => {
        if (login !== null) {
            dispatch(resetLoginResponse())
            if (login.result === true) {
                localStorage.setItem('userData', JSON.stringify(login.response.client_detail))
                localStorage.setItem('token', JSON.stringify(login.response.token))
                window.location.replace('/dashboard')
                window.location.reload()
            } else {
                switch (login.status_code) {
                    case 101:
                        toast.error(login.message, {
                            duration: TOAST_DURATION,
                            position: TOAST_POSITION,
                            style: {
                                color: TOAST_ERROR_COLOR
                            }
                        })
                        break;
                    default:
                        toast.error(login.message, {
                            duration: TOAST_DURATION,
                            position: TOAST_POSITION,
                            style: {
                                color: TOAST_ERROR_COLOR
                            }
                        })
                }
            }
        }
    }, [login])

    const onSubmit = async (data) => {

        dispatch(actionLogin({
            email: data.email,
            password: data.password
        }))
    };

    return (
        <div className="cover">
            <section>
                <div className="mt-5">
                    <div className="container-xxl container-fluid">
                        <div className="row d-flex justify-content-center align-items-center py-5">
                            <div className="col-md-9 col-lg-6">
                                <h1 class="">
                                    Track your policies <br />
                                    <span class="fw-bold">hassle-free</span>
                                </h1>
                                <p class="mt-3">
                                    Automate your day-to-day insurance administration processes with PINC’s admin dashboard.  Keep a track of your on-going and expired policies. The dashboard offers a set of tools like Policy wallet to record any kind of insurance, Renewal reminders, Claim intimations, Active & Inactive policy hub, Company profile and Service support.
                                </p>
                                <div className="d-flex my-4">
                                    <div className="col-6 d-flex">
                                        <div className="w-50">
                                            <img
                                                src={`${SUB_DIRECTORY}/assets/images/1041916.png`}
                                                className="w-75"
                                                alt=""
                                            />
                                        </div>
                                        <div className="my-auto w-100">
                                            <b>Get Claim</b>
                                            <p className="mb-0">Assistance</p>
                                        </div>
                                    </div>
                                    <div className="col-6 d-flex">
                                        <div className="w-50">
                                            <img
                                                src={`${SUB_DIRECTORY}/assets/images/1041887.png`}
                                                className="w-75"
                                                alt=""
                                            />
                                        </div>
                                        <div className="my-auto w-100">
                                            <b>Explore</b>
                                            <p className="mb-0">Policies</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-8 col-lg-5 offset-lg-1">
                                <div className="card shadow">
                                    {/*START: Sign in Form */}
                                    <div className="card-body">
                                        <form
                                            noValidate
                                            autoComplete="off"
                                            onSubmit={handleSubmit(
                                                onSubmit
                                            )}
                                        >                                            <div className="align-items-center justify-content-center justify-content-lg-start mb-3">
                                                <p className="lead fw-bold me-3 text-secondary">
                                                    Sign in with <span className="text-dark">CIMS</span>
                                                </p>
                                            </div>
                                            {/* mobile input */}
                                            <div className="form-outline mb-4">
                                                <label className="form-label" htmlFor="email">
                                                    Email ID
                                                </label>
                                                <input
                                                    type="text"
                                                    id="email"
                                                    name="email"
                                                    className="form-control form-control-lg"
                                                    placeholder="Enter a valid email id"
                                                    {...register(
                                                        "email",
                                                        {
                                                            required: "This is required.",
                                                            pattern: {
                                                                value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                                                                message: "invalid email address"
                                                            }
                                                        }
                                                    )}
                                                />
                                                {errors.email && (
                                                    <ErrorLabel
                                                        message={
                                                            errors
                                                                .email
                                                                ?.message
                                                        }
                                                    />
                                                )}
                                            </div>
                                            {/* Password input */}
                                            <div className="form-outline mb-3">
                                                <label className="form-label" htmlFor="pwd">
                                                    Password
                                                </label>
                                                <div className="input-group">
                                                    <input
                                                        className="form-control form-control-lg"
                                                        type={passwordShown ? "text" : "password"}
                                                        id="pwd"
                                                        name="password"
                                                        placeholder="Password"
                                                        {...register(
                                                            "password",
                                                            {
                                                                required: "This is required.",
                                                            }
                                                        )}
                                                    />
                                                    <span className="input-group-text">
                                                        {
                                                            passwordShown ?
                                                                <img
                                                                    src={`${SUB_DIRECTORY}/assets/images/icon/svg/eye-open.svg`}

                                                                    onClick={togglePasswordVisiblity} />
                                                                :
                                                                <img
                                                                    src={`${SUB_DIRECTORY}/assets/images/icon/svg/eye-close.svg`}
                                                                    onClick={togglePasswordVisiblity}
                                                                />
                                                        }

                                                    </span>
                                                </div>
                                                {errors.password && (
                                                    <ErrorLabel
                                                        message={
                                                            errors
                                                                .password
                                                                ?.message
                                                        }
                                                    />
                                                )}
                                            </div>
                                            <div className="d-flex justify-content-between align-items-center">
                                                <a
                                                    className="text-body"
                                                    onClick={() => {
                                                        navigate('/forgot-password')
                                                    }}
                                                >
                                                    Forgot password?
                                                </a>
                                            </div>
                                            <div className="text-center text-lg-start mt-4 pt-2">
                                                <button type="submit" className="btn btn-primary w-100" onClick={() => { }}>
                                                    Sign In
                                                </button>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>

    )

}

export default Login;